<!-- 服务详情 -->


<template>
  <!--案例详情-->
  <div class="c-main-detailbox c-product-box">
    <!-- <div data-v-64177ade="" class="c-bread-crumbs">
        <a data-v-64177ade="" href="#">机构</a> &gt; <a data-v-64177ade="" href="#">智慧场景</a> &gt; <a data-v-64177ade="" href="#">产品详情</a>
    </div> -->
    <div class="back" @click="$router.back(-1)">
      <i class="el-icon-back" style="cursor:pointer"> 返回 </i>
    </div>
    <div class="c-detail-top-box">
      <div class="c-detial-left">
        <img :src="imgPreviews[0]">
        <div class="c-gs-detail">
          <img :src="serviceInfo.org.logo">
          <div class="c-gs-txt" @click="openOrg">
            <p>{{serviceInfo.org.organization}}</p>
          </div>
        </div>
      </div>

      <div class="c-detial-right">
        <h2>{{serviceInfo.serviceName}}</h2>
        <p class="c-txt">服务类型：{{serviceInfo.serviceCategory}}<br>项目领域：{{serviceInfo.industryCategory}}</p>
        <div class="c-price-btn">
          <p>服务地址：{{serviceInfo.province }}{{serviceInfo.district}}{{ serviceInfo.address}}</p>
          <p>联系人：{{serviceInfo.contacts}}</p>
          <p>联系电话：{{serviceInfo.mobile}}</p>
          <p class="product-price">服务定价：<span>{{serviceInfo.nonamount?'价格面议':(serviceInfo.amountLower/10000)+'万元-'+(serviceInfo.amountUpper/10000)+'万元'}}</span></p>
        </div>
        <button v-show="isproject" id="ksbm" @click="sigup">快速报名</button>
      </div>
    </div>

    <div class="c-detail-list">
      <div class="c-detail-items">
        <h3>服务详情</h3>
        <div class="information">
          <p class="w950">{{serviceInfo.serviceDescription}}</p>
        </div>
      </div>
    </div>
    <!-- <ProjectSigup :showDailog="showDailog" :pid="sid" v-on:dataChange="showHide"></ProjectSigup> -->
  </div>
</template>

<script>
  import {
    getServiceById,
  } from '@/api/service';
  import config from '@/config/index';
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import {
    getProject,
  } from '@/api/project.js'
  import {
    MessageBox
  } from 'element-ui';
  import ProjectSigup from '@/components/ProjectSigup.vue'
  import {
    projectSingup
  } from '@/api/project.js'
  export default {
    name: 'ServiceDetail',
    components: {
      ProjectSigup,
    },
    data() {
      return {
        isproject: false,
        sid: '',
        uid: '',
        serviceInfo: {
          org: {}
        },
        imgPreviews: [],
        showDailog: false,
      }
    },
    mounted() {
      this.sid = this.$route.query.sid;
      if (this.sid) {
        this.isproject = false
        this.queryInfo(this.sid);
        this.uid = getCacheUserInfo().uid;
      } else {
        this.isproject = true
        this.sid = this.$route.query.projectid;
        // console.log(this.sid)
        this.queryProjectDetail()
      }

    },
    methods: {
      showHide(param) {
        this.showDailog = param.show
      },
      // sigup(){
      //   this.showDailog = true
      // },
      queryProjectDetail() {
        this.$http.get(getProject(this.sid)).then((res) => {
          if (res.code === 1) {
            console.log(res);
            let project = res.data
            this.serviceInfo.serviceName = project.title
            this.serviceInfo.serviceDescription = project.projectdetail
            this.serviceInfo.contacts = project.contacts
            this.serviceInfo.createTime = project.createTime
            this.serviceInfo.district = project.district
            this.serviceInfo.province = project.province
            this.serviceInfo.mobile = project.mobile
            this.serviceInfo.industrycategory = project.industrycategory
            this.serviceInfo.img = project.imgs
            this.serviceInfo.serviceCategory = project.projectcategory
            this.serviceInfo.address = project.address
            this.serviceInfo.amountLower = project.amountlower
            this.serviceInfo.amountUpper = project.amountupper
            if (project.org) {
              this.serviceInfo.org = project.org
              this.serviceInfo.orgid = project.org.orgid
            } else {
              this.serviceInfo.logo = project.userInfo.headimg
              this.serviceInfo.organization = project.userInfo.organization
            }
            this.initData();
          }
        });
      },
      queryInfo(sid) {
        if (!sid) return;
        this.$http.get(getServiceById(sid)).then((res) => {
          if (res.code === 1) {
            console.log(res);
            this.serviceInfo = res.data;
            this.initData();
          }
        });
      },
      initData() {
        if (this.serviceInfo) {
          const keys = Object.keys(this.serviceInfo);
          keys.forEach((key) => {
            this[key] = this.serviceInfo[key];
          });
          if (this.img && typeof this.img === 'string') {
            let imgs = JSON.parse(this.img);
            this.imgKeys = imgs;
            if (imgs && imgs.length > 0) {
              imgs = imgs.map((img) => {
                return `${config.HOST_IMG}${img}`;
              });
            }
            this.imgPreviews = imgs;
          }
          if (this.serviceInfo.org) {
            this.serviceInfo.org.logo = `${config.HOST_IMG}${this.serviceInfo.org.logo}`;
          } else {
            this.serviceInfo.org = {};
          }
        }
      },
      openOrg() {
        // MessageBox.alert('平台功能完全开放后可查看机构详情', '平台建设中', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     MessageBox.message({
        //       type: 'info',
        //       message: `action: ${ action }`
        //     });
        //   }
        // });
        if (this.serviceInfo.orgid) {
          this.$router.push('/detail/org-detail?orgid=' + this.serviceInfo.orgid);
        }
      },
      sigup() {
        let userinfo = getCacheUserInfo()
        let params = {
          pid: this.sid, //账号id
          uid: userinfo.uid, //用户id
          contacts: userinfo.name, //联系人
          mobile: userinfo.account, //手机号
          content: "无", //留言内容
        }

        this.$http.post(projectSingup(),
          params
        ).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success("报名成功");
          }
        });
      },
    }
  }
</script>

<style scoped>
  @import url(./service-detail.css);

  #ksbm {
    width: 92px;
    line-height: 38px;
    height: 38px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border: 1px solid #267FF2;
    float: left;
    background: #267FF2;
    margin-top: 5px;
  }

  @media screen and (max-width: 850px) {
    #ksbm {
      line-height: .72rem;
      height: .72rem;
      font-size: .26rem;
    }
  }
</style>
